import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { Compliance } from "@/components/site/Compliance";
import { WhatWeDeliver } from "@/components/site/WhatWeDeliver";
import { Facilities } from "@/components/site/Facilities";
import { Pricing } from "@/components/site/Pricing";
import { ApiSection } from "@/components/site/ApiSection";
import { Faq } from "@/components/site/Faq";
import { QuoteForm } from "@/components/site/QuoteForm";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Compliance />
        <WhatWeDeliver />
        <Facilities />
        <Pricing />
        <ApiSection />
        <Faq />
        <QuoteForm />
      </main>
      <Footer />
    </div>
  );
}
